module.exports = __webpack_public_path__ + "img/work1.931a8ce5.png";